// ============================================================
// BOLD BRASILEIRO — Header scroll state
// Adiciona .is-scrolled na .site-head quando rola
// ============================================================

(function () {
    'use strict';

    const header = document.getElementById('header');
    if (!header) return;

    const update = () => {
        if (window.scrollY > 30) {
            header.classList.add('is-scrolled');
        } else {
            header.classList.remove('is-scrolled');
        }
    };

    document.addEventListener('scroll', update, { passive: true });
    update();
})();
